import { render } from "./NodeCard.vue?vue&type=template&id=bee04b1c&scoped=true"
import script from "./NodeCard.vue?vue&type=script&lang=js"
export * from "./NodeCard.vue?vue&type=script&lang=js"

import "./NodeCard.vue?vue&type=style&index=0&id=bee04b1c&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bee04b1c"]])

export default __exports__